define(function(require, exports, module) {
    'use strict';
    const user = require('user');
    const MenuView = require('modules/menu/menu.view');
    const $ = require('j');
    const core = require('core');
    const device = require('util/device.util');
    const { dispatcher } = require('bundle');
    var _ = require('underscore');
    var scrollManager = require('managers/scroll.manager');

    module.exports = MenuView.extend({

        render: function() {
            _.invoke(this.childViews, 'close');

            this.childViews = [];

            this.menuItems = this.model.getFilteredByRoleItems();
            this.menuItems = this.getFilteredByUrlAvailability();

            this._sideAndNavigationMenu();

            if (!this.slideMenuWcId) {
                this.attachWidget(this.$el.accordion({
                    isCollapseSiblings: false,
                    headerExpandedClass: 'fn-accordion-header_expanded slide-menu__list__header_expanded',
                    bodyExpandedClass: 'fn-accordion-body_expanded slide-menu__list__body_expanded'
                }));
            }

            this.activateMenu(this.backgroundPage);

            return this;
        },

        subscribe: function() {
            MenuView.prototype.subscribe.apply(this, arguments);

            dispatcher.listen('menu:items', this.render.bind(this));
        },

        handleLinkNavigate: function(event) {
            const target = event.target;
            const li = target.closest('.fn-play-bingo');
            const logout = target.closest('.fn-logout');

            if (logout) {
                event.preventDefault();

                core.trigger('auth:action:logout');

                return;
            }

            else if (li) {
                event.preventDefault();
                event.stopPropagation();
                event.stopImmediatePropagation();

                const link = li.querySelector('a');
                const url = link.getAttribute('href');

                this._launchBingo(url);

                return;
            }

            return MenuView.prototype.handleLinkNavigate.apply(this, arguments);
        },

        _launchBingo: function handler(url) {
            if (!Playtech.API.auth.isLoggedIn) {
                Playtech.API.popup.showPopup('login', {
                    onLogin: () => handler(url)
                });
                return;
            }

            const { username } = Playtech.fetchUserDetails();

            if (Playtech.API.device.isDesktop) {
                const win = window.open('about:blank', '_blank', 'popup,width=1024,height=768');

                win.location.href = `${url}&username=${username}`;
            } else {
                location.href = `${url}&username=${username}`;
            }
        },

        _renderSideMenu: function() {
            this.$el.html(this.tmpl('side.menu', {
                menuItems: this.menuItems,
                isUserLogged: user.isLoggedIn(),
                userName: user.get('userName')
            }).replace());

            this.wrap = this.$('.fn-menu-wrap')[0];
            this.list = this.$('.fn-menu-list')[0];
        },

        toggleSecondlevelMenu: function(pageUrl) {
            var parentItem = this.model.getCurrentParentItem(pageUrl);
            if (!parentItem) {
                this.$('.fn-secondlevel-wrapper, .fn-secondlevel').addClass('hidden');

                return;
            }

            var parentUrl = parentItem.friendlyURL;
            var $menu = this.$('[data-parent-url="' + parentUrl + '"]');
            var isVisible = Boolean($menu.length > 0 && $menu[0].children.length > 0);

            this.$('.fn-secondlevel-wrapper').toggleClass('hidden', !isVisible);
            this.$('.fn-secondlevel').addClass('hidden');

            $('.fn-secondlevel-wrapper.hidden').length
                ? $('.header').removeClass('header-with-secondlvel')
                : $('.header').addClass('header-with-secondlvel');

            isVisible && $menu.removeClass('hidden');

            core.trigger('menu:secondLevel:toggle');
        },

        close: function(callback) {
            if (!this.opened) {
                return;
            }

            scrollManager.enableScrolling(this);
            $(window).off('.menu');

            this.$el.addClass('close');

            this.transitionEnd(this.$('.fn-slide-menu-wrapper'), function() {
                this.$el.removeClass('open close');
                if (_.isFunction(callback)) {
                    callback();
                }
            }, this);

            this.removeOverlay();

            $('.fn-page').removeClass('page_state_menu-open');

            core.trigger('menu:action:leftMenuClosed');

            this.opened = false;
        },

        open: function() {
            if (this.wrap) {
                this.wrap.scrollTop = 0;
            }

            // prevent body scrolling while menu is open
            scrollManager.disableScrolling(this);

            // hack: ios > 9 fix menu appearing shifted below bottom if opened from lowest scroll position
            if (device.os === 'ios' && parseInt(device.osVersion) >= 9) {
                this.redraw(this.el);
            }
            // hack: adding setTimeout fixes animation on open when `this.redraw()` is called
            window.setTimeout(function() {
                this.$el.addClass('open');
                this.renderOverlay(this.$el);
                $('.fn-page').addClass('page_state_menu-open');
                this.opened = true;
            }.bind(this), 0);
        },

        _sideAndNavigationMenu: function() {
            var navMenu = this.tmpl('nav.menu', {
                menuItems: this.menuItems,
                urlToIsMenuHovered: this.urlToIsMenuHovered,
                isDesktop: device.formFactor === 'desktop',
            }).replace();

            var sideMenu = this.tmpl('side.menu', {
                menuItems: this.menuItems,
                isUserLogged: user.isLoggedIn(),
                userName: user.get('userName')
            }).replace();

            if (this.slideMenuWcId) {
                this.$el.find('.fn-common-slide-menu').remove();

                this.$el.html(navMenu.replace());
                return;
            }

            this.$el.html(sideMenu);
            this.$el.append(navMenu);

            this.wrap = this.$('.fn-menu-wrap')[0];
            this.list = this.$('.fn-menu-list')[0];
        },

        setActiveMenu: function(pageUrl) {
            this.$('.active').removeClass('active');

            const currentParentItems = this.model.getCurrentParentItems(pageUrl);
            const currentItem = this.model.getCurrentItem(pageUrl);
            const currentParentItem = this.model.getCurrentParentItem(pageUrl);

            [...currentParentItems, currentItem, currentParentItem].forEach(function(item) {
                if (!item) {
                    return;
                }
                var $link = this.$('[data-url="' + item.friendlyURL + '"]');
                var $specifyLink = this.$('[data-specify-url="' + item.friendlyURL + '"]:not(.disabled-menu-point):not(.fn-accordion)');
                var $icon = $link.find('[class*="micon-"]');

                if(!this.$el[0].closest('.menu__nav-wrapper')) {
                    var $headerLink = this.$('.menu__nav-wrapper [data-url="' + item.friendlyURL + '"]');

                    $headerLink && $headerLink.addClass('active');
                }

                !$link.hasClass('fn-accordion') && $link.addClass('active') && $icon.addClass('active');
                $specifyLink.addClass('active');
            }, this);

            document.querySelector('.menu__nav-wrapper').scrollLeft = 0;
        },
    });
});
